import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import { useDispatch, useSelector } from 'react-redux';
import { createGuide, deleteGuide, fetchGuides, updateGuide } from '../../data/slices/guideSlice';
import Guide from '../../data/schemas/guide';
import { notify } from '../../settings/toastSetting';
import { Dialog, Box, Paper, Typography } from '@mui/material';
import { Add, Hiking } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import PageHeader from '../../components/layout/PageHeader';
import useIsAdmin from '../../hooks/useIsAdmin';

const GuidePage = (props) => {
    const { guides } = useSelector((state) => state.guides);
    const dispatch = useDispatch();
    const isAdmin = useIsAdmin();
    const [guide, setGuide] = useState(null);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setGuide(null);
    }

    const addGuide = (data, cb) => {
        handleClose();
        if (data.id) {
            updateGuide(data, (err) => output(err), (resp) => {
                cb();
                notify("Le guide a été enregistré avec succès !");
                dispatch(fetchGuides());
            });
            return;
        }

        createGuide(data, (err) => output(err), (resp) => {
            notify("Le guide a été ajouté avec succès !");
            dispatch(fetchGuides());
        });
    }

    const onDelete = (id) => {
        handleClose();
        deleteGuide(id, (err) => output(err), (resp) => {
            setGuide(null);
            notify("Le guide a bien été supprimé !");
            dispatch(fetchGuides());
        });
    }

    const onGuideSelected = (id) => {
        setGuide(guides.find((g) => g.id === id));
        setOpen(true);
    }

    useEffect(() => {
        dispatch(fetchGuides());
    }, [dispatch]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <PageHeader 
                title="Gestion des Guides"
                subtitle="Gérez vos guides accompagnateurs et leurs spécialités"
                icon={Hiking}
                breadcrumbs={[
                    { label: 'Paramètres', path: '/parametres' },
                    { label: 'Guides', path: '/parametres/guides' }
                ]}
                actions={isAdmin ? [
                    { 
                        label: 'Ajouter un guide', 
                        icon: <Add />, 
                        onClick: () => { setGuide(null); setOpen(true); },
                        color: 'primary'
                    }
                ] : []}
            />

            <Paper elevation={0} sx={{ 
                borderRadius: '16px', 
                overflow: 'hidden', 
                border: '1px solid',
                borderColor: COLORS.gray[200],
                bgcolor: 'white'
            }}>
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: COLORS.gray[100], bgcolor: COLORS.gray[50] }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.secondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Liste des guides ({guides.length})
                    </Typography>
                </Box>
                
                <StyledTable
                    rows={[...guides].sort((a,b) => sortByProp(a, b, 'nomComplet'))}
                    head={Object.keys(new Guide())}
                    onOptionClicked={onGuideSelected}
                />
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '20px', p: 1 }
                }}
            >
                <Transform
                    onSubmit={addGuide}
                    mandatories={["nomComplet", "telephone"]}
                    entity={new Guide()}
                    toUpdate={guide}
                    onDelete={isAdmin ? onDelete : undefined}
                    onCancel={handleClose}
                />
            </Dialog>
        </Box>
    );
}

export default GuidePage;
